module.exports = "/images/bluecircle.png?c6b5d985590c3a91dbbd4883fd447dbc";